// extracted by mini-css-extract-plugin
export default {"skeleton-grid":"VirtualSources_skeleton-grid__OX8Sv","loadingSpinner-container":"VirtualSources_loadingSpinner-container__U+ylb"};